export default __webpack_public_path__ + "static/media/screenshot1.99d41809.jpg";